// extracted by mini-css-extract-plugin
module.exports = {"cardArea":"bankDisplay_cardArea__1hRO4","cardLogo":"bankDisplay_cardLogo__uS7B-","nameNumber":"bankDisplay_nameNumber__tvklu"};